import React, { useCallback, useEffect, useRef } from "react";
import {
  getBezierPath,
  BaseEdge,
  EdgeLabelRenderer,
} from "@xyflow/react";

export const CircleArrowEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  data
}) => {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  const coinRef = useRef(null);

  const animate = useCallback(() => {
    coinRef.current.style.display = "block";
    const animation = coinRef.current.animate(
      [
        { offsetDistance: "0%" },
        { offsetDistance: "100%" },
      ],
      {
        duration: 2000,
        easing: "linear",
      }
    );
    animation.onfinish = () => {
      // Hide the coin after it finishes
      if (!coinRef.current) return;
      coinRef.current.style.display = "none";
    };
  }, [coinRef]);

  useEffect(() => {
    if (!coinRef.current) return;

    let interval;
    const timeout = setTimeout(() => {
      animate();
      interval = setInterval(() => {
        animate()
      }, 10000);
    }, data.delay);
    return () => {
      if (interval) {
        clearInterval(interval);
      }
      clearTimeout(timeout);
    };
  }, [data, animate]);

  return (
    <>
      {/* Static edge line (no animation, clean) */}
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          stroke: "#3b82f6",
          strokeWidth: 2,
          ...style,
        }}
      />

      {/* Floating coin animation along the path */}
      <EdgeLabelRenderer>
        <svg
          style={{
            position: "absolute",
            overflow: "visible",
            pointerEvents: "none",
            zIndex: 10,
          }}
        >
          <path id={`path-${id}`} d={edgePath} fill="none" stroke="none" />

          <g
            ref={coinRef}
            style={{
              offsetPath: `path('${edgePath}')`,
              offsetRotate: "auto",
              display: "none",
            }}
          >
            <circle r={16} fill="#FFD700" strokeWidth={2} stroke="#D1B000" />
            <text
              x="0"
              y="3"
              textAnchor="middle"
              fontSize="9"
              fontFamily="Inter, serif"
              fill="#000"
              fontWeight="bold"
            >
              ZTGM
            </text>
          </g>
        </svg>
      </EdgeLabelRenderer>
    </>
  );
};
